import { Decoration } from '@tiptap/pm/view'
// import {
//   AiChangesOptions
// } from './ai-changes/ai-changes-extension'
import { AIExtension } from './ai-extension'
import { AiSuggestion, AiSuggestionOptions } from './ai-suggestion'
import { SuggestionPopover } from './ai-suggestion/components/SuggestionPopover'
import { StreamContentExtension } from './stream-content-extension'
import { aiSuggestionPluginKey } from './ai-suggestion/plugin'
import { type AiSuggestionCustomResolverOptions, type Suggestion } from './ai-suggestion/types'

export {
  StreamContentExtension,
  AIExtension,
  AiSuggestion,
  SuggestionPopover,
  aiSuggestionPluginKey,
  type AiSuggestionCustomResolverOptions,
  type Suggestion,
  type AiSuggestionOptions,
}

export const createAIExtensions = ({
  suggestionOptions,
  // changesOptions,
}: {
  suggestionOptions?: AiSuggestionOptions & {
    popoverRef?: React.RefObject<HTMLElement | null>
  }
  // changesOptions?: AiChangesOptions
}) => [
  StreamContentExtension,
  AIExtension.configure({
    apiEndpoint: `${import.meta.env.VITE_SERVER_URL}/api/ai/editor`,
  }),
  // NOTE: AI Changes are disabled currently.
  // AiChangeMark,
  // AiChangeOldMark,
  // AiChangesExtension.configure({
  //   getCustomDecorations({ change, isSelected, getDefaultDecorations }) {
  //     const decorations = getDefaultDecorations()
  //     if (isSelected) {
  //       decorations.push(
  //         Decoration.widget(change.newRange.to, () => {
  //           const element = document.createElement('span')
  //           element.className = 'ai-change-popover-anchor'
  //           if (changesOptions?.popoverRef) {
  //             changesOptions.popoverRef.current = element
  //           }
  //           return element
  //         })
  //       )
  //     }
  //     return decorations
  //   },
  // }),
  AiSuggestion.configure({
    loadOnStart: false, // Don't load suggestions automatically
    rules: [
      // Add rules
      // {
      //   id: '1',
      //   title: 'Spell Check',
      //   prompt: 'Identify and correct any spelling mistakes',
      //   color: '#DC143C',
      //   backgroundColor: '#FFE6E6',
      // },
      // {
      //   id: '2',
      //   title: 'Grammar Check',
      //   prompt: 'Identify and correct any grammar mistakes',
      //   color: '#FFD700',
      //   backgroundColor: '#FFFACD',
      // },
    ],
    // Use default decorations for highlighting changes
    getCustomSuggestionDecoration({
      suggestion,
      isSelected,
      getDefaultDecorations,
    }) {
      const decorations = getDefaultDecorations()

      if (isSelected) {
        decorations.push(
          Decoration.widget(suggestion.deleteRange.to, () => {
            const element = document.createElement('span')
            if (suggestionOptions?.popoverRef) {
              suggestionOptions.popoverRef.current = element
            }
            return element
          })
        )
      }
      return decorations
    },
    ...suggestionOptions,
  }),
]
